import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Lightbulb = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16.125 2.00002C10.613 2.00002 6.125 7.38802 6.125 14C6.125 17.712 7.563 21.225 10 23.488V26C10 28.2 11.8 30 14 30H18C20.2 30 22 28.2 22 26V23.712C24.587 21.462 26.125 17.837 26.125 13.999C26.125 7.38702 21.637 1.99902 16.125 1.99902V2.00002ZM20 26C20 27.1 19.1 28 18 28H14C12.9 28 12 27.1 12 26V24H20V26ZM20.913 22H17V17.337L19.8 13.599C19.925 13.437 20 13.224 20 12.999C20 12.449 19.55 11.999 19 11.999C18.675 11.999 18.387 12.161 18.2 12.399L16 15.337L13.8 12.399C13.612 12.161 13.325 11.999 13 11.999C12.45 11.999 12 12.449 12 12.999C12 13.224 12.075 13.437 12.2 13.599L15 17.337V22H11.338C9.313 20.113 8.125 17.15 8.125 14C8.125 8.48802 11.713 4.00002 16.125 4.00002C20.537 4.00002 24.125 8.48802 24.125 14C24.125 17.15 22.937 20.113 20.913 22Z" />
	</svg>
);

export default Lightbulb;
